import Autocomplete from '@mui/material/Autocomplete'
import Checkbox from '@mui/material/Checkbox'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import React, { useState } from 'react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'

export interface OptionType {
    id: number | string
    label: string
}

interface MultiSelectProps {
    options: OptionType[]
    selectedOptions: OptionType[]
    label: string
    placeholder: string
    onSelectionChange: (
        value: OptionType[]
    ) => void | React.Dispatch<React.SetStateAction<OptionType[]>>
    allowSelectAll?: boolean
    disabled?: boolean
    style?: React.CSSProperties
}

const MultiSelectAutocomplete: React.FC<MultiSelectProps> = ({
    options,
    selectedOptions: selectedValues,
    label,
    placeholder,
    onSelectionChange,
    allowSelectAll = true,
    disabled = false,
    style = {},
}) => {
    const [selectAll, setSelectAll] = useState(false)

    const handleSelectAllToggle = () => {
        if (selectAll) {
            onSelectionChange([]) // Deselect all
        } else {
            onSelectionChange(options) // Select all
        }
        setSelectAll(!selectAll)
    }

    const handleChange = (
        _event: React.ChangeEvent<object>,
        newValue: OptionType[]
    ) => {
        // Check if all options are selected
        const allSelected = newValue.length === options.length
        setSelectAll(allSelected)
        onSelectionChange(newValue)
    }

    return (
        <div>
            {allowSelectAll && (
                <Button
                    onClick={handleSelectAllToggle}
                    variant="contained"
                    color="primary"
                    disabled={disabled}
                >
                    {selectAll ? 'Deselect All' : 'Select All'}
                </Button>
            )}
            <Autocomplete
                style={{ width: 500, marginTop: 16, ...style }}
                multiple
                disabled={disabled}
                options={options}
                value={selectedValues}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.label}
                onChange={handleChange}
                disableCloseOnSelect
                renderOption={(props, option, { selected }) => (
                    <li {...props}>
                        <Checkbox
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            style={{ marginRight: 8 }}
                            checked={selected}
                        />
                        {option.label}
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        placeholder={placeholder}
                    />
                )}
            />
        </div>
    )
}

export default MultiSelectAutocomplete
